import { Alert, Snackbar } from '@mui/material';
import { TableTitleBox } from '../../common';
import DirectDebitIcbcDataTable from './components/DirectDebitIcbcDataTable';
import DirectDebitIcbcFilters from './components/DirectDebitIcbcFilters';
import DirectDebitIcbcSummary from './components/DirectDebitIcbcSummary';
import { useDirectDebitIcbc } from './hooks/useDirectDebitIcbc';

const DirectDebitIcbc = () => {
  const {
    filter,
    preview,
    analysis,
    records,
    excluded,
    summary,
    snackbar,
    isLoading,
    isExporting,
    isAnalysisLoading,
    handleFilter,
    handleSelectAnalysisDate,
    handleSearch,
    handleExport,
    handleCloseSnackbar,
  } = useDirectDebitIcbc();

  return (
    <>
      <TableTitleBox title="Habitat 99 | Cupones | Débito Directo ICBC" />

      <DirectDebitIcbcFilters
        filter={filter}
        recordsCount={records.length}
        analysis={analysis}
        isLoading={isLoading}
        isExporting={isExporting}
        isAnalysisLoading={isAnalysisLoading}
        onFilter={handleFilter}
        onSelectAnalysisDate={handleSelectAnalysisDate}
        onSearch={handleSearch}
        onExport={handleExport}
      />

      <DirectDebitIcbcSummary summary={summary} period={preview?.period} />

      <DirectDebitIcbcDataTable records={records} excluded={excluded} isLoading={isLoading} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4500}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DirectDebitIcbc;
